import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { PlanoAcao } from '../../models/plano-acao.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { IndicadoresAtividadeSituacaoService } from '../../services/indicadores-atividade-situacao.service';
import { IndicadoresAtividadeService } from '../../services/indicadores-atividade.service';
import { IndicadoresPgAtividadeSituacaoService } from '../../services/indicadores-pg-atividade-situacao.service';
import { IndicadoresPgAtividadeService } from '../../services/indicadores-pg-atividade.service';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { PlanoAcaoSituacaoService } from '../../services/plano-acao-situacao.service';
import { PlanoAcaoService } from '../../services/plano-acao.service';

@Component({
  selector: 'app-detalhe-projeto-plano-acao-view',
  templateUrl: './detalhe-projeto-plano-acao-view.component.html',
  styleUrls: ['./detalhe-projeto-plano-acao-view.component.scss']
})
export class DetalheProjetoPlanoAcaoViewComponent extends BaseListComponent<PlanoAcao> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  planoAcao: PlanoAcao;
  isIndicador: boolean;
  isPgIndicador: boolean;
  pgType: string = '';

  constructor(
    private planoAcaoService: PlanoAcaoService,
    private atividadeService: IndicadoresAtividadeService,
    private pgAtividadeService: IndicadoresPgAtividadeService,
    private planoAcaoSituacao: PlanoAcaoSituacaoService,
    private atividadeSituacao: IndicadoresAtividadeSituacaoService,
    private pgAtividadeSituacao: IndicadoresPgAtividadeSituacaoService,
    private activatedRoute: ActivatedRoute,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super()
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
    });
    this.planoAcao = this.activatedRoute.snapshot.data['entity'];
    this.isIndicador = this.activatedRoute.snapshot.data['isIndicador'];
    this.isPgIndicador = this.activatedRoute.snapshot.data['isPgIndicador'];
    this.pgType = this.activatedRoute.snapshot.data['type'];
    this.loaded();
  }

  initList() {
    if (this.isPgIndicador) {
      this.addSub(
        this.pgAtividadeService.getByIdSimple(this.planoAcao?.id).subscribe({
          next: (res) => {
            this.planoAcao = res;
            this.loaded();
          },
        })
      )
    } else if (this.isIndicador) {
      this.addSub(
        this.atividadeService.getByIdSimple(this.planoAcao?.id).subscribe({
          next: (res) => {
            this.planoAcao = res;
            this.loaded();
          },
        })
      )
    } else {
      this.addSub(
        this.planoAcaoService.getByIdSimple(this.planoAcao?.id).subscribe({
          next: (res) => {
            this.planoAcao = res;
            this.loaded();
          },
        })
      )
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  editar() {
    if (this.isIndicador) {
      return ['/projetos', 'projeto', this.idProjeto, 'atividade', this.planoAcao?.id, 'editar'];
    } else if (this.isPgIndicador) {
      return ['/projetos', this.pgType ?? 'agregador', 'atividade', this.planoAcao?.id, 'editar'];
    } else {
      return ['/projetos', 'projeto', this.idProjeto, 'plano-acao', this.planoAcao?.id, 'editar'];
    }
  }

  voltar() {
    if (this.planoAcao?.prt_issue_id) {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'entregas', this.planoAcao?.prt_issue_id]);
    } else if (this.planoAcao?.ind_id) {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'indicadores', this.planoAcao?.ind_id]);
    } else if (this.planoAcao?.pg_ind_id) {
      this.navigation.back(['projetos', this.pgType ?? 'agregador', 'indicadores', this.planoAcao?.pg_ind_id]);
    } else {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'pontos-criticos']);
    }
  }

  editarSituacao(id: number) {
    if (this.isIndicador) {
      return ['/projetos', 'projeto', this.idProjeto, 'atividade', 'situacao', id, 'editar'];
    } else if (this.isPgIndicador) {
      return ['/projetos', this.pgType ?? 'agregador', 'atividade', 'situacao', id, 'editar'];
    } else {
      return ['/projetos', 'projeto', this.idProjeto, 'plano-acao', 'situacao', id, 'editar'];
    }
  }

  novoSituacao() {
    if (this.isIndicador) {
      return ['/projetos', 'projeto', this.idProjeto, 'atividade', 'situacao', this.planoAcao?.id, 'adicionar'];
    } else if (this.isPgIndicador) {
      return ['/projetos', this.pgType ?? 'agregador', 'atividade', 'situacao', this.planoAcao?.id, 'adicionar'];
    } else {
      return ['/projetos', 'projeto', this.idProjeto, 'plano-acao', 'situacao', this.planoAcao?.id, 'adicionar'];
    }
  }

  novaDemandaLink() {
    return ['/projetos', 'projeto', this.idProjeto, 'demandas', 'adicionar'];
  }

  novaDemandaParams(id: number) {
    if (this.isIndicador) {
      return { pf_ind_action_analysis_id: id };
    } else {
      return { pf_prt_issue_action_analysis_id: id };
    }
  }

  confirmExcluir(idSituacao) {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluirSituacao(idSituacao);
      }
    });
  }

  excluirSituacao(id: number) {
    this.loading();
    if (this.isIndicador) {
      this.atividadeSituacao.delete(id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.initList();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    } else if (this.isPgIndicador) {
      this.pgAtividadeSituacao.delete(id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.initList();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    } else {
      this.planoAcaoSituacao.delete(id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.initList();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    }
  }
}
